/**
 * Class-based animations
 */

const ani = () => {


  // if we have elements and observer is supported
	if(!!window.IntersectionObserver){

    // add .is-shown class once .ani starts to enter view (i.e. the top of .ani hits bottom of viewport)
		const observer = new IntersectionObserver(([{isIntersecting, target}]) => {
			target.classList.toggle('is-shown', isIntersecting);
		}, {rootMargin: '10px 0px -50px'});
		document.querySelectorAll('.ani').forEach(el => {
			observer.observe(el);
		});

	}

	// I'm keeping the following around because it's quite useful
	// and it may be useful to implement on this site in the future.

	// // if we have an .ani--onload (will only be one at most per page)
	// const aniOnLoad = document.querySelector('.ani--onload');
	// if(aniOnLoad){
	// 	// show the element after a bit if it's already cached
	// 	if(aniOnLoad.complete){
	// 		setTimeout(() => {
	// 			aniOnLoad.classList.add('shown');
	// 		}, 100);
	// 	// show the element after it loads for the first time
	// 	} else {
	// 		aniOnLoad.addEventListener('load', () => {
	// 			aniOnLoad.classList.add('shown');
	// 		});
	// 	}
	// }


};

export default ani;